module.exports = __webpack_public_path__ + "static/media/zip-water.dc248752.png";